<template>
  <div id="companyIndicators">
    <div class="item item-box">
      <div class="title">营收与利润</div>
      <div class="box-content">
        <div class="item-r huan-type">
          <div class="item-title">营收（年/季/月）</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.revenue" :dw="'%'"></DomLegend>
            <DomeEchartWrap ref="cRevenue" id="c-revenue" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-r huan-type">
          <div class="item-title">净利润（年/季/月）</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.netProfit" :dw="'%'"></DomLegend>
            <DomeEchartWrap ref="cNetProfit" id="c-netProfit" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-r huan-type">
          <div class="item-title">产品线指标</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.product" :dw="'%'"></DomLegend>
            <DomeEchartWrap ref="cProduct" id="c-product" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-r huan-type">
          <div class="item-title">效率指标</div>
          <div class="chart-wrap xl-chart">
            <RangkProgress :list="PopularCities"></RangkProgress>
          </div>
        </div>
      </div>
    </div>
    <div class="item item-box">
      <div class="title">产品服务</div>
      <div class="box-content">
        <div class="item-r huan-type">
          <div class="item-title">量指标</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.quantitative" dw="万"></DomLegend>
            <DomeEchartWrap ref="cQuantitative" id="c-quantitative" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-r huan-type">
          <div class="item-title">率指标</div>
          <div class="chart-wrap">
            <DomLegend dw="%" :lists="CompanyIndicators.rateIndex"></DomLegend>
            <DomeEchartWrap ref="cRateIndex" id="c-rateIndex" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-r huan-type ">
          <div class="item-title">服务指标</div>
          <div class="chart-wrap card-wrap">
            <BscSmallCard class="card-item" v-for="item in cServiceIndicatorsLists" :item="item"></BscSmallCard>
          </div>
        </div>
        <div class="item-r huan-type item-r-left">
          <div class="item-title">体验指标</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.experienceIndicators"></DomLegend>
            <DomeEchartWrap ref="cExperienceIndicators" id="c-experienceIndicators" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
      <!-- <div class="item-r huan-type">
          <div class="item-title">率指标</div>
          <div class="chart-wrap">
            <DomLegend dw="%" :lists="CompanyIndicators.rateIndex"></DomLegend>
            <DomeEchartWrap ref="cRateIndex" id="c-rateIndex" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div class="item item-box">
      <div class="title">服务</div>
      <div class="box-content">
        <div class="item-r huan-type ">
          <div class="item-title">服务指标</div>
          <div class="chart-wrap card-wrap">
            <BscSmallCard class="card-item" v-for="item in cServiceIndicatorsLists" :item="item"></BscSmallCard>
          </div>
        </div>
        <div class="item-r huan-type item-r-left">
          <div class="item-title">体验指标</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.experienceIndicators"></DomLegend>
            <DomeEchartWrap ref="cExperienceIndicators" id="c-experienceIndicators" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { inject, onMounted, reactive, ref, getCurrentInstance } from '@vue/composition-api'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import DomLegend from '../components/domLegend.vue'
import RangkProgress from '../components/rangkProgress.vue'
import BscSmallCard from '../components/domSmallCard.vue'

import { UserRateIndexEchartOp, CProductEchart, CRevenueEchartOp } from '../js/index.js'

export default {
  name: 'CompanyIndicators',
  props: [

  ],
  setup (props, ctx) {
    const vm = getCurrentInstance()
    let cServiceIndicatorsLists = reactive([
      {
        name: '投诉量',
        val: 0,
        hb: 0,
        tb: 0
      },
      {
        name: '投诉率',
        val: 0,
        hb: 0,
        tb: 0
      },
      {
        name: '满意率',
        val: 0,
        hb: 0,
        tb: 0
      },
      {
        name: '平均解决时长',
        val: '0h',
        hb: 0,
        tb: 0
      }
    ])
    let PopularCities = reactive([
      // { 'name': '人均劳效', 'count': 3, 'rate': '100', dw: '万' },
      // { 'name': '费用率', 'count': 89.40, 'rate': '89.40', dw: '%' },
      // { 'name': '研发费用率', 'count': 83.97, 'rate': '83.97', dw: '%' },
      // { 'name': '存货周转', 'count': 6.21, 'rate': '6.21', dw: '%' },
      // { 'name': '应收周转', 'count': 4.19, 'rate': '4.19', dw: '%' },
      // { 'name': 'ROE', 'count': 0.79, 'rate': '0.79', dw: '%' }
    ])
    let CompanyIndicators = reactive({
      revenue: {},
      netProfit: {},
      product: {},
      experienceIndicators: {},
      quantitative: {},
      rateIndex: {}
    })
    let cRevenue = ref(null)
    let cNetProfit = ref(null)
    let cProduct = ref(null)
    let cExperienceIndicators = ref(null)
    let cQuantitative = ref(null)
    let cRateIndex = ref(null)
    let cQuantitative1 = ref(null)
    let cQuantitative2 = ref(null)
    let cQuantitative3 = ref(null)
    let cQuantitative4 = ref(null)
    let cRateIndex1 = ref(null)
    let cRateIndex2 = ref(null)
    let cRateIndex3 = ref(null)
    let cRateIndex4 = ref(null)
    // 营收
    let revenue = reactive({
      name: ['月达成率', '季达成率', '年达成率'],
      nameLabel: ['年', '季', '月'],
      // data: [83.41, 79.64, 89.64],
      data: [],
      max: 100,
      rate: {
        // hb: [0.45, -0.48, -0.47],
        hb: [],
        // tb: [0.67, -0.59, 0.47],
        tb: []
      }
    })
    // 产品指标
    let product = reactive({
      name: [],
      // name: ['会员收入占比', '流量收入占比', '软件收入占比', '硬件收入占比'],
      // data: [12.15, 6.5, 0.1, 1.43],
      data: [],
      rate: {
        hb: [],
        // hb: [-0.48, 25.76, 351.02, -10.26],
        tb: []
        // tb: [18.97, -22.03, 0, -45.49],
      }
    })
    // 率指标
    let experienceIndicators2 = {
      name: ['月均活跃率', '日均活跃率', '会员渗透率', '日均会员转化率'],
      data: [],
      max: 100,
      rate: {
        hb: [],
        tb: []
      }
    }
    // 产品---量指标
    let experienceIndicators1 = {
      name: ['月活终端', '日活终端', '会员数', '新增会员'],
      data: [],
      max: 20000,
      rate: {
        hb: [],
        tb: []
      }
    }
    function initCreateBarRate () {
      CompanyIndicators.revenue = revenue
      CompanyIndicators.product = product
      cRevenue.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: revenue
      }))

      // 净利润
      let netProfit = {
        name: ['月达成率', '季达成率', '年达成率'],
        nameLabel: ['年', '季', '月'],
        data: [46.58, 49.58, 93.93],
        max: 100,
        rate: {
          hb: [0.45, -0.48, -0.47],
          tb: [0.67, -0.59, 0.47]
        }
      }
      cNetProfit.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: netProfit
      }))
      CompanyIndicators.netProfit = netProfit

      cProduct.value.setEchartOption(CProductEchart({ v: this,
        data: product
      }))
      // 体验指标
      let experienceIndicators = {
        name: ['体验旅程', '卡设计', '按顺序排列', '硬件收入'],
        data: [0, 0, 0, 0],
        max: 20000,
        rate: {
          hb: [0, 0, 0, 0],
          tb: [0, 0, 0, 0]
        }
      }

      cExperienceIndicators.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: experienceIndicators
      }))
      CompanyIndicators.experienceIndicators = experienceIndicators

      // 量指标
      cQuantitative.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: experienceIndicators1
      }))
      // cQuantitative3.value.setEchartOption(CRevenueEchartOp({ v: this,
      //   data: experienceIndicators1
      // }))
      CompanyIndicators.quantitative = experienceIndicators1
      // cQuantitative2.value.setEchartOption(UserRateIndexEchartOp({}))
      // cQuantitative4.value.setEchartOption(UserRateIndexEchartOp({}))
      // 率指标
      cRateIndex.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: experienceIndicators2
      }))
      // cRateIndex3.value.setEchartOption(CRevenueEchartOp({ v: this,
      //   data: experienceIndicators2
      // }))
      // cRateIndex2.value.setEchartOption(UserRateIndexEchartOp({}))
      // cRateIndex4.value.setEchartOption(UserRateIndexEchartOp({}))
      CompanyIndicators.rateIndex = experienceIndicators2
    }

    onMounted(() => {
      getOrgData()
    })
    let userId = inject('userId')

    /// ////获取数据
    function getOrgData () {
      vm.proxy.$service.fetch({
        url: '/api/bsc/index',
        params: {
          userId
        }
      }).then(res => {
        if (!res) {
          vm.proxy.$alert('您暂未设置公司指标', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `action: ${action}`
              })
            }
          })
          return
        }
        console.log(res)
        let { income, produceLineVOS, rateVO, efficiencyCharList, amountVO } = res.companyVO
        revenue.data = [income.yearBscIncome.completeRate ?? 0, income.quarterBscIncome.completeRate ?? 0, income.monthBscIncome.completeRate ?? 0]
        revenue.max = Math.max(...[income.yearBscIncome.completeRate ?? 0, income.quarterBscIncome.completeRate ?? 0, income.monthBscIncome.completeRate ?? 0]) * 1.2
        revenue.rate.hb = [income.yearBscIncome.mratio ?? 0, income.quarterBscIncome.mratio ?? 0, income.monthBscIncome.mratio ?? 0]
        revenue.rate.tb = [income.yearBscIncome.yratio ?? 0, income.quarterBscIncome.yratio ?? 0, income.monthBscIncome.yratio ?? 0]
        /// /产品
        produceLineVOS.slice(0, 4).map(v => {
          let { type, completeRate, mratio, ytatio } = v
          product.name.push(type)
          product.data.push(completeRate ?? 0)
          product.rate.hb.push(mratio ?? 0)
          product.rate.tb.push(ytatio ?? 0)
        })
        // 率指标
        experienceIndicators2.data = [rateVO.monthAcitveRateIndicator.periodRate ?? 0, rateVO.dayAvgActiveIndicator.periodRate ?? 0, rateVO.memberRateIndicator.periodRate ?? 0, rateVO.avgMemberRateIndicator.periodRate ?? 0]
        experienceIndicators2.max = Math.max(...[rateVO.monthAcitveRateIndicator.periodRate ?? 0, rateVO.dayAvgActiveIndicator.periodRate ?? 0, rateVO.memberRateIndicator.periodRate ?? 0, rateVO.avgMemberRateIndicator.periodRate ?? 0]) * 1.2
        experienceIndicators2.rate.hb = [rateVO.monthAcitveRateIndicator.mRatio ?? 0, rateVO.dayAvgActiveIndicator.mRatio ?? 0, rateVO.memberRateIndicator.mRatio ?? 0, rateVO.avgMemberRateIndicator.mRatio ?? 0]
        experienceIndicators2.rate.tb = [rateVO.monthAcitveRateIndicator.yRatio ?? 0, rateVO.dayAvgActiveIndicator.yRatio ?? 0, rateVO.memberRateIndicator.yRatio ?? 0, rateVO.avgMemberRateIndicator.yRatio ?? 0]
        // 量指标
        experienceIndicators1.data = [amountVO.monthActiveIndicator.periodRate ?? 0, amountVO.dayActiveIndicator.periodRate ?? 0, amountVO.newMemberIndicator.periodRate ?? 0, amountVO.yxMemberIndicator.periodRate ?? 0]
        experienceIndicators1.max = Math.max(...[amountVO.monthActiveIndicator.periodRate ?? 0, amountVO.dayActiveIndicator.periodRate ?? 0, amountVO.newMemberIndicator.periodRate ?? 0, amountVO.yxMemberIndicator.periodRate ?? 0]) * 1.2
        experienceIndicators1.rate.hb = [amountVO.monthActiveIndicator.mRatio ?? 0, amountVO.dayActiveIndicator.mRatio ?? 0, amountVO.newMemberIndicator.mRatio ?? 0, amountVO.yxMemberIndicator.mRatio ?? 0]
        experienceIndicators1.rate.tb = [amountVO.monthActiveIndicator.yRatio ?? 0, amountVO.dayActiveIndicator.yRatio ?? 0, amountVO.newMemberIndicator.yRatio ?? 0, amountVO.yxMemberIndicator.yRatio ?? 0]

        // 效率指标
        efficiencyCharList.forEach(v => {
          let { name, valueAll, value } = v
          PopularCities.push({
            name,
            count: valueAll,
            rate: (/万/g.test(valueAll)) ? 100 : valueAll.replace('%', '')
          })
        })
        initCreateBarRate()
      })
    }
    return {
      cServiceIndicatorsLists,
      CompanyIndicators,
      PopularCities,
      cRevenue,
      cProduct,
      cNetProfit,
      cExperienceIndicators,
      cQuantitative,
      cRateIndex
    }
  },
  components: {
    DomeEchartWrap,
    DomLegend,
    RangkProgress,
    BscSmallCard
  }
}
</script>

<style scoped lang="stylus">

#companyIndicators
  .item-box
    .title
      border-bottom: 1px solid #999999cc
      padding-bottom: 15px
.box-content
  display: flex;
  flex-wrap: wrap;
  padding 10px
.item-r
  .chart-wrap
    display flex
    flex-grow: 0 1
    margin-bottom: 10px
    margin-right: 20px
    justify-content: space-between
    .canvas-wrap
      width 228px
      height 180px
  .sing-wrap
    .canvas-wrap
      width 100%
  .chart-wrap.card-wrap
    flex-wrap: wrap
    justify-content: space-between
    align-content: center
    .card-item
      width 188.5px
      height 85.5px
      padding 10px
    .card-item:nth-of-type(n+3)
      margin-top 10px
    .card-item:nth-of-type(2n)
      margin-left: 10px
  .xl-chart,.card-wrap,.sing-wrap
    width 388px
  .chart-wrap-lists
    display flex
  .item-title
    color: #000
    text-align center
    margin: 0 0 10px 0
    font-size: 22px
    font-weight: bolder
    width 100%
@media screen and (max-width:2560px)
  .box-content
    justify-content: space-between
@media screen and (max-width:1900px)
  .box-content
    justify-content: space-between
    .item-r:last-of-type
      margin-right: auto
@media screen and (max-width:1500px)
  .box-content
    justify-content: space-around
    .item-r:last-of-type
      margin-right: initial

</style>

.item-r+.item-r
  margin-left 19px
.item-r.item-r-left
  margin-left 0
